import { createFileRoute } from "@tanstack/react-router"
import { queryClient } from "@/queryClient"
import {
  getAssignmentOptions,
  getReviewDraftOptions,
  listMyAllocationsOptions,
} from "@/client/@tanstack/react-query.gen"
import ReviewWorkspace from "@/routes/-pages/ReviewWorkspace"
import { runBackendModePrefetch } from "@/utils/routePrefetch"

export const Route = createFileRoute("/assessment/$assessmentId/review/$reviewId")({
  loader: ({ params }) => {
    const { assessmentId, reviewId } = params
    return runBackendModePrefetch(() =>
      Promise.all([
        queryClient.prefetchQuery(getAssignmentOptions({ path: { assignment_id: assessmentId } })),
        queryClient.prefetchQuery(listMyAllocationsOptions({ path: { assignment_id: assessmentId } })),
        queryClient.prefetchQuery(
          getReviewDraftOptions({
            path: { assignment_id: assessmentId, allocation_id: reviewId },
          }),
        ),
      ]),
    )
  },
  component: ReviewWorkspace,
})
